// import {
//   ApolloClient,
//   HttpLink,
//   InMemoryCache,
//   ApolloLink,
//   split,
// } from '@apollo/client';
// import { WebSocketLink } from '@apollo/client/link/ws';
// import { getMainDefinition } from '@apollo/client/utilities';
// import { APP_TOKEN } from '../constants';

// const ENABLE_WEBSOCKET = true;
// let wsLink = null;
// let link = null;
// const cache = new InMemoryCache();
// const httpLink = new HttpLink({
//   uri: `${process.env.REACT_APP_GRAPHQL_ENDPOINT}/`,
// });
// if (ENABLE_WEBSOCKET) {
//   wsLink = new WebSocketLink({
//     uri: `${process.env.REACT_APP_WS_ENDPOINT}`,
//     options: {
//       reconnect: true,
//     },
//   });
// }

// // const errorLink = onError(({ graphQLErrors, networkError }) => {
// //   if (graphQLErrors) {
// //     // graphQLErrors.forEach(({ message, extensions: { code } }) => {
// //     //   switch (code) {
// //     //     case 'UNAUTHENTICATED':
// //     //       console.warn('Error (UNAUTHENTICATED) : ', message);
// //     //       break;
// //     //     case 'BAD_USER_INPUT':
// //     //       console.error('Error (BAD_USER_INPUT) : ', message);
// //     //       toast.error(`Invalid input passed`);
// //     //       break;
// //     //     case 'INTERNAL_SERVER_ERROR':
// //     //       console.error('Error (INTERNAL_SERVER_ERROR) : ', message);
// //     //       break;
// //     //     case 'GRAPHQL_VALIDATION_FAILED':
// //     //       console.error('Error (GRAPHQL_VALIDATION_FAILED) : ', message);
// //     //       toast.error('Validation error occured.');
// //     //       break;
// //     //     default:
// //     //       console.error('Error : ', message);
// //     //       toast.error('Something went wrong');
// //     //       break;
// //     //   }
// //     // });
// //   } else if (networkError) {
// //     if (typeof window !== 'undefined' && !window.navigator.onLine)
// //       toast.info(`Sorry, Your browser is offline.`);
// //     else toast.error('Network Error : Faild to fetch data');
// //   }
// // });

// const authMiddleware = new ApolloLink((operation, forward) => {
//   /*
//   NOTE: we have an object stored in the local storage thats why parsing it
//   and then passing the token in header. If your application not storing object then
//   change the code to match your logic, also check the userContext and make changes accordingly
//   */
//   // const getData = async () => {
//   //   const jwtToken = await localStorage.getItem(APP_TOKEN);
//   //   return jwtToken;
//   // };
//   const userData = JSON.parse(localStorage.getItem(APP_TOKEN));
//   if (userData && userData.token) {
//     operation.setContext({
//       headers: {
//         authorization: `Bearer ${userData.token}`,
//       },
//     });
//   }

//   return forward(operation);
// });
// if (ENABLE_WEBSOCKET) {
//   link = split(
//     ({ query }) => {
//       const definition = getMainDefinition(query);
//       return (
//         definition.kind === 'OperationDefinition' &&
//         definition.operation === 'subscription'
//       );
//     },
//     wsLink,
//     ApolloLink.from([authMiddleware, httpLink]),
//   );
// } else {
//   link = ApolloLink.from([authMiddleware, httpLink]);
// }

// const client = new ApolloClient({
//   cache,
//   link,
// });

// export default client;

// import {
//   ApolloClient,
//   HttpLink,
//   InMemoryCache,
//   ApolloLink,
//   split,
// } from '@apollo/client';
// import { WebSocketLink } from '@apollo/client/link/ws';
// import { getMainDefinition } from '@apollo/client/utilities';
// import { APP_TOKEN } from '../constants';

// const ENABLE_WEBSOCKET = true;
// let wsLink = null;
// let link = null;
// const cache = new InMemoryCache();

// // Production API endpoints
// const httpLink = new HttpLink({
//   uri: 'https://api.polystox.com/graphql',
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// if (ENABLE_WEBSOCKET) {
//   wsLink = new WebSocketLink({
//     uri: 'wss://api.polystox.com/subscriptions',
//     options: {
//       reconnect: true,
//       connectionParams: () => {
//         const userData = JSON.parse(localStorage.getItem(APP_TOKEN));
//         return userData && userData.token ? {
//           authToken: userData.token,
//           authorization: `Bearer ${userData.token}`
//         } : {};
//       },
//     },
//   });
// }

// const authMiddleware = new ApolloLink((operation, forward) => {
//   const userData = JSON.parse(localStorage.getItem(APP_TOKEN));

//   // Add all required headers
//   const headers = {
//     'Content-Type': 'application/json',
//   };

//   if (userData && userData.token) {
//     headers['authorization'] = `Bearer ${userData.token}`;
//     headers['x-safir-token'] = userData.token; // Added this header based on your screenshot
//   }

//   operation.setContext({
//     headers: headers,
//   });

//   return forward(operation);
// });

// // Error handling middleware
// const errorMiddleware = new ApolloLink((operation, forward) => {
//   return forward(operation).map(response => {
//     if (response.errors) {
//       console.error('GraphQL Errors:', response.errors);
//     }
//     return response;
//   });
// });

// if (ENABLE_WEBSOCKET) {
//   link = split(
//     ({ query }) => {
//       const definition = getMainDefinition(query);
//       return (
//         definition.kind === 'OperationDefinition' &&
//         definition.operation === 'subscription'
//       );
//     },
//     wsLink,
//     ApolloLink.from([authMiddleware, errorMiddleware, httpLink]),
//   );
// } else {
//   link = ApolloLink.from([authMiddleware, errorMiddleware, httpLink]);
// }

// const client = new ApolloClient({
//   cache,
//   link,
//   defaultOptions: {
//     watchQuery: {
//       errorPolicy: 'all',
//     },
//     query: {
//       errorPolicy: 'all',
//     },
//     mutate: {
//       errorPolicy: 'all',
//     },
//   },
// });

// export default client;

// dev-----------

import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
  split,
} from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { onError } from '@apollo/client/link/error';
import { APP_TOKEN } from '../constants';

const ENABLE_WEBSOCKET = true;
let wsLink = null;
let link = null;
const cache = new InMemoryCache();

// Environment variables se URLs le rahe hain
const GRAPHQL_ENDPOINT =
  process.env.REACT_APP_GRAPHQL_ENDPOINT ||
  process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT ||
  'https://api-dev.polystox.co.in/graphql';
const WS_ENDPOINT =
  process.env.REACT_APP_WS_ENDPOINT ||
  process.env.NEXT_PUBLIC_WS_ENDPOINT ||
  'wss://api-dev.polystox.co.in/subscriptions';

// eslint-disable-next-line no-console
console.log('🔧 Apollo Config:', {
  graphql: GRAPHQL_ENDPOINT,
  websocket: WS_ENDPOINT,
});

const httpLink = new HttpLink({
  uri: GRAPHQL_ENDPOINT,
});

if (ENABLE_WEBSOCKET) {
  wsLink = new WebSocketLink({
    uri: WS_ENDPOINT,
    options: {
      reconnect: true,
      connectionParams: () => {
        const userData = JSON.parse(localStorage.getItem(APP_TOKEN));
        return userData && userData.token ? { authToken: userData.token } : {};
      },
    },
  });
}

const authMiddleware = new ApolloLink((operation, forward) => {
  const userData = JSON.parse(localStorage.getItem(APP_TOKEN));
  if (userData && userData.token) {
    operation.setContext({
      headers: {
        authorization: `Bearer ${userData.token}`,
      },
    });
  }
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const handleLogout = () => {
    localStorage.removeItem(APP_TOKEN);
    window.location.href = '/login';
  };

  if (graphQLErrors) {
    graphQLErrors.forEach((err) => {
      const msg = err.message ? err.message.toLowerCase() : '';
      const code = err?.extensions?.code;
      if (
        code === 'UNAUTHENTICATED' ||
        msg.includes('disabled') ||
        msg.includes('unauthorized') ||
        msg.includes('invalid token')
      ) {
        handleLogout();
      }
    });
  }

  if (networkError) {
    if (networkError.statusCode === 401 || networkError.statusCode === 403) {
      handleLogout();
    }
  }
});

if (ENABLE_WEBSOCKET) {
  link = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    ApolloLink.from([errorLink, authMiddleware, httpLink]),
  );
} else {
  link = ApolloLink.from([errorLink, authMiddleware, httpLink]);
}

const client = new ApolloClient({
  cache,
  link,
});

export default client;
